import { render, staticRenderFns } from "./CreateEditFile.vue?vue&type=template&id=50e38bf7&scoped=true"
import script from "./CreateEditFile.vue?vue&type=script&lang=js"
export * from "./CreateEditFile.vue?vue&type=script&lang=js"
import style0 from "./CreateEditFile.vue?vue&type=style&index=0&id=50e38bf7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e38bf7",
  null
  
)

export default component.exports